import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { CustomerType } from "src/app/shared/types/contract-types";

@Injectable({
  providedIn: "root",
})
export class CustomerService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/customer/${endpoint}`;
  }

  getCustomer(customerId: number): Observable<CustomerType> {
    return this.http.get<CustomerType>(
      this.apiUrlWithEndpoint(`${customerId}`),
    );
  }

  updateCustomer(
    customerId: number,
    customer: CustomerType,
  ): Observable<CustomerType> {
    return this.http.put<CustomerType>(
      this.apiUrlWithEndpoint(`${customerId}`),
      customer,
    );
  }
}
